import styled from "styled-components";
import { BASIC_DARK_GRAY } from "../../../constants/colors";
import { useAsset } from "../../../hooks/useAsset";
import { useAuth } from "../../../hooks/useAuth";
import { BackToTopPageButton } from "../../molecules/BackToTopPageButton";
import { CustomerInfoForm } from "../../organisms/form/CustomerInfoForm";
import { useCustomerInfo } from "./hook";

export const CustomerInfo: React.FC = () => {
  const { showSms } = useAsset();
  const { handleEmailError } = useAuth();
  const { handleCustomerInfo, handleSendEmail } = useCustomerInfo();

  return (
    <Container>
      <TitleWrapper id="customer_info">新規会員登録</TitleWrapper>
      {showSms ? (
        <>
          <TitleContent>認証コードの発行</TitleContent>
          <Content>
            ご本人様確認のため、認証コードを送信します。メールアドレスまたは、携帯番号を入力し「送信する」を押してください。
          </Content>
          <Content2>
            ※メールまたは、携帯電話のSMS（ショートメッセージサービス）に認証コードが届きます。
          </Content2>
        </>
      ) : (
        <>
          <TitleContent>
            <p>仮登録メールアドレス入力</p>
          </TitleContent>
          <Content>
            当サイトでは、メールアドレスをIDとしてご利用いただきます。ご注文者登録されるメールアドレスを入力していただき、｢送信する｣をクリックしてください。
          </Content>
        </>
      )}

      {showSms !== null && (
        <CustomerInfoForm
          showSms={showSms}
          handleEmailError={handleEmailError}
          handleSubmit={handleCustomerInfo}
          handleSubmitEmail={handleSendEmail}
        />
      )}
      <ButtonWrapper>
        <BackToTopPageButton />
      </ButtonWrapper>
    </Container>
  );
};

const Container = styled.div`
  color: ${BASIC_DARK_GRAY};
  padding: 0 16px 51px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  text-align: left;
`;

const TitleWrapper = styled.div`
  font-size: 20px;
  padding: 43px 0 38px 0;
  display: flex;
  font-weight: 500;
  justify-content: center;
  line-height: 1;
  font-family: "Hiragino Sans";
`;

const TitleContent = styled.div`
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  margin-bottom: 6px;
  font-family: "Hiragino Sans";
`;

const Content = styled.p`
  text-align: left;
  font-weight: 300;
  margin-bottom: 16px;
  font-family: "Hiragino Sans";
`;

const Content2 = styled.p`
  text-align: left;
  font-weight: 300;
  margin-bottom: 36px;
  text-indent: -1em;
  margin-left: 1em;
  font-family: "Hiragino Sans";
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  button {
    font-family: "Hiragino Sans";
    font-weight: 600;
    line-height: 1em;
    height: auto;
  }
`;
